export enum Entity {
  Customer = 'customer',
  DeliveryNote = 'delivery-note',
  Product = 'product',
  Repair = 'repair',
  Sale = 'sale',
  Stock = 'stock',
}
